import {
	account_1,
	account_2,
	account_3,
	account_4,
	account_5,
} from '../assets/images/account/images.js';

const options_account = [
	{
		title: 'Как создать лицевой счет',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейдите в Похозяйственную книгу, в которой нужно внести лицевой счет.',
				],
				image: account_1.account_1_1,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выберите из списка Глав ЛПХ необходимую карточку.',
				],
				image: account_1.account_1_2,
			},
			{
				text: ['7. В карточке Главы ЛПХ жмем кнопку “Редактировать”'],
				image: account_1.account_1_3,
			},
			{
				text: ['8. Внизу страницы выберите “Создать ЛС”.'],
				image: account_1.account_1_4,
			},
			{
				text: [
					'9. Заполните все необходимые поля в появившемся окне формы.',
					'10. Нажмите на кнопку «Сохранить» в правом верхнем углу.',
					'11. Лицевой счет создан.',
				],
				image: account_1.account_1_5,
			},
		],
	},
	{
		title: 'Добавление ранее созданного лицевого счета',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейдите в Похозяйственную книгу, в которой нужно внести лицевой счет.',
				],
				image: account_2.account_2_1,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выберите из списка Глав ЛПХ необходимую карточку.',
				],
				image: account_2.account_2_2,
			},
			{
				text: ['7. В карточке Главы ЛПХ жмем кнопку “Редактировать”'],
				image: account_2.account_2_3,
			},
			{
				text: ['8. Внизу страницы выберите “Добавить из реестра”.'],
				image: account_2.account_2_4,
			},
			{
				text: [
					'9. Выбираем из списка нужный лицевой счет (на данном примере лицевых счетов нет).',
				],
				image: account_2.account_2_5,
			},
			{
				text: [
					'10. Открылось окно "Привязка ЛС к главе ЛПХ необратима. Вы хотите сохранить?", в котором нужно нажать кнопку "Сохранить".',
				],
				image: account_2.account_2_6,
			},
			{
				text: ['11. Лицевой счет добавлен.'],
			},
		],
	},
	{
		title: 'Как посмотреть реестр лицевых счетов',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Реестр лицевых счетов» в левом боковом меню.',
					'3. На экране появится список лицевых счетов.',
				],
				image: account_3.account_3_1,
				label: true,
			},
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно посмотреть карточки ЛПХ.',
				],
				image: account_3.account_3_2,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выберите из списка Глав ЛПХ необходимую карточку.',
				],
				image: account_3.account_3_3,
			},
			{
				text: [
					'7. В нужной карточке Главы ЛПХ отобразится список лицевых счетов.',
				],
				image: account_3.account_3_4,
			},
		],
	},
	{
		title: 'Как редактировать лицевой счет',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Реестр лицевых счетов» в левом боковом меню.',
					'3. На экране появится список лицевых счетов.',
					'4. Выберите из списка лицевой счет для редактирования.',
				],
				image: account_4.account_4_1,
			},
			{
				text: ['5. Нажмите на кнопку «Редактировать» в правом верхнем углу.'],
				image: account_4.account_4_2,
			},
			{
				text: [
					'6. Внесите изменения в появившемся окне формы лицевого счета. ',
					'7. Нажмите на кнопку «Сохранить» в правом верхнем углу.',
					'8. Изменения сохранены.',
				],
				image: account_4.account_4_3,
				label: true,
			},
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно внести лицевой счет.',
				],
				image: account_4.account_4_4,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выберите из списка Глав ЛПХ необходимую карточку.',
				],
				image: account_4.account_4_5,
			},
			{
				text: ['7. Выберите нужный лицевой счет для редактирования.'],
				image: account_4.account_4_7,
			},
			{
				text: ['8. Нажмите на кнопку “Редактировать”'],
				image: account_4.account_4_8,
			},
			{
				text: [
					'9. Внесите изменения в появившемся окне формы лицевого счета.',
					'10. Нажмите на кнопку «Сохранить» в правом верхнем углу.',
					'11. Изменения сохранены.',
				],
				image: account_4.account_4_9,
			},
		],
	},
	{
		title: 'Как закрыть действующий лицевой счет',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Реестр лицевых счетов» в левом боковом меню.',
					'3. На экране появится список лицевых счетов.',
					'4. Выберите из списка лицевой счет, который необходимо закрыть.',
				],
				image: account_5.account_5_1,
			},
			{
				text: ['5. Нажмите на кнопку «Редактировать» в правом верхнем углу.'],
				image: account_5.account_5_2,
			},
			{
				text: [
					'6. Поставьте галочку напротив «Счет закрыт» в самом верху формы.',
					'7. Укажите причину закрытия лицевого счета в поле «Прекращение прав на земельный участок ввиду».',
					'8. Нажмите на кнопку «Сохранить».',
					'9. Лицевой счет закрыт.',
				],
				image: account_5.account_5_3,
				label: true,
			},
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно внести лицевой счет.',
				],
				image: account_5.account_5_4,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выберите из списка Глав ЛПХ необходимую карточку.',
				],
				image: account_5.account_5_5,
			},
			{
				text: ['7. Выберите нужный лицевой счет для закрытия.'],
				image: account_5.account_5_7,
			},
			{
				text: [
					'8. Поставьте галочку напротив «Счет закрыт» в самом верху формы.',
					'9. Укажите причину закрытия лицевого счета в поле «Прекращение прав на земельный участок ввиду».',
					'10. Нажмите на кнопку «Сохранить».',
					'11. Лицевой счет закрыт.',
				],
				image: account_5.account_5_8,
			},
		],
	},
];

export default options_account;
